export const modalResolverMapByType = {};
